import { DealerBranchEnum, IDealer } from "../model/types";

export const getToggleableBranchColumns = (
  excludeItems: (keyof IDealer)[],
): (keyof IDealer)[] =>
  (Object.keys(DealerBranchEnum) as (keyof IDealer)[]).filter(
    (key) => !excludeItems.includes(key),
  );

export const sanitizeBranchColumnsHideList = (
  value: (keyof IDealer | string)[],
  excludeItems: (keyof IDealer)[],
): (keyof IDealer)[] => {
  const toggleable = new Set(getToggleableBranchColumns(excludeItems));

  return value.filter((col) =>
    toggleable.has(col as keyof IDealer),
  ) as (keyof IDealer)[];
};
